import React, { useState, useEffect, useRef, useContext } from "react";
import { AiOutlineSend } from "react-icons/ai";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { getAllSubcontractor } from "../../webServices/Apis";
import { useNavigate } from 'react-router';
import { UserContext } from '../../App';
import { message } from "antd";
import Avtar from '../../images/noProfile.jpg'

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAe2ojT88XINP-WeQXY0aZ0R_RL3A4U2X4",
  authDomain: "axcell-painting-app.firebaseapp.com",
  projectId: "axcell-painting-app",
  storageBucket: "axcell-painting-app.firebasestorage.app",
  messagingSenderId: "893434188108",
  appId: "1:893434188108:web:d65324fe0a49537252ffe9",
  measurementId: "G-DSMVYVCHH0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Chat = () => {
  const [subContractors, setSubContractors] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [fetchedMessages,setFetchedMessages]=useState([])
  const chatEndRef = useRef(null); // Reference to the bottom of the chat
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);


// Scroll to the bottom of the chat
   const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

   

 useEffect(() => {
    if (!selectedUser) return; // Exit if no user is selected
    scrollToBottom();
    const adminId = localStorage.getItem("userId");
    let chatroomId = "";
    if (selectedUser?.id > adminId) {
      chatroomId = `${selectedUser.id}-${adminId}`;
    } else {
      chatroomId = `${adminId} - ${selectedUser.id}`;
    }
    // Reference to the messages collection for the selected chatroom
    const messagesRef = collection(db, "chatroom", chatroomId, "message");

    // Query to fetch messages ordered by createdAt (ascending)
    const q = query(messagesRef, orderBy("timestamp", "asc"));

    // Listen for real-time updates
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const fetchedMessages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })); 

      setFetchedMessages(fetchedMessages)
      scrollToBottom(); // Scroll to the bottom when new messages arrive
    });

    // Cleanup the listener when component is unmounted or selectedUser changes
    return () => unsubscribe();
  }, [selectedUser]);

  // Fetch subcontractors from API
  const getSubcontractors = async () => {
    setLoading(true);
    try {
      const response = await getAllSubcontractor();
      if (response?.data?.success) {
        setSubContractors(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching subcontractors:", error);
      
      if (error?.response?.status === 401 ) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      } 
      if (error?.response?.status === 500){
        message.error("Server not responding")
        return;
      } 
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired")
        localStorage.clear()
        setIsAuthenticated(false)
        window.location.href = "/login";
      }
      else {
        return;
      }
    } 
    finally {
      setLoading(false);
    }


  };



  // Handle sending a message
  const handleSendMessage = async () => {
    if (!newMessage.trim() || !selectedUser) return;

    try {
      const adminId = localStorage.getItem("userId");
      let chatroomId = "";
      if (selectedUser?.id > adminId) {
        chatroomId = `${selectedUser.id}-${adminId}`;
      } else {
        chatroomId = `${adminId} - ${selectedUser.id}`;
      }


      // Reference to the specific chatroom in Firestore
     
      const messagesRef = collection(db, "chatroom", chatroomId, "message");

      // Send the message with a timestamp using luxon
      await addDoc(messagesRef, {
        idFrom: localStorage.getItem("userId"),
        idTo: selectedUser.id,
        content: newMessage.trim(),
        type: "text",
        sender: "You",
        isRead: false,
        timestamp: Date.now(), // Corrected here
      });

      setNewMessage(""); // Clear the input field
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  // Fetch subcontractors on mount
  useEffect(() => {
    getSubcontractors();
  }, []);



  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp); // Convert to Date object
    const hours = date.getHours(); // Get hours
    const minutes = date.getMinutes(); // Get minutes
    const formattedTime = `${hours % 12 || 12}:${minutes.toString().padStart(2, "0")} ${
      hours >= 12 ? "PM" : "AM"
    }`; // Format to 12-hour clock with AM/PM
    return formattedTime; // Return formatted time
  };
  

  // const ChatWindow = ({ selectedUser, fetchedMessages }) => {
  //   const chatEndRef = useRef(null); // Ref for scrolling to the bottom
  
  //   // Scroll to the bottom whenever `fetchedMessages` or `selectedUser` changes
  //   useEffect(() => {
  //     if (chatEndRef.current) {
  //       chatEndRef.current.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }, [fetchedMessages, selectedUser]);
  // }

  const filteredSubContractors = subContractors.filter((subContractor) =>
    `${subContractor.firstName} ${subContractor.email}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );


  return (
    <>
    
    <div className="flex h-screen bg-gray-100">
    
      {/* Subcontractors List */}
      <div className="w-1/3 bg-green-500 text-white overflow-y-auto scrollbar-hidden">
        <div className="py-4 border-b ">
          {/* Search Box */}
          <input
            type="text"
            placeholder="Search subcontractors..."
            className="flex justify-center items-center ml-6 w-96 p-2 rounded-lg text-black"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {loading ? (
          <p className="p-4 text-center">Loading subcontractors...</p>
        ) : (
          filteredSubContractors.map((subContractor) => (
            <div
              key={subContractor.id}
              onClick={() => setSelectedUser(subContractor)}
              className={`p-4 cursor-pointer hover:bg-green-600 ${selectedUser?.id === subContractor.id ? "bg-green-900" : ""
                }`}
            >
              <div className="flex items-center">
                <img
                  src={subContractor.profileImage || Avtar}
                  alt="subcontractor"
                  className="w-10 h-10 rounded-full mr-3 border"
                />
                <div>
                  <p className="font-bold">{subContractor.firstName}</p>
                  <p className="text-sm">{subContractor.email}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>



      {/* Chat Window */}
      <div className="flex-1 flex flex-col bg-white">
        {selectedUser ? (
          <>
            {/* Chat Header */}

            <div className="py-4 bg-green-400 text-white flex items-center">
              
              <img
                src={selectedUser.profileImage || Avtar}
                alt="subcontractor"
                className="w-10 h-10 rounded-full mr-3 ml-2 border"
              />
              <div>
                <h2 className="font-bold">{selectedUser.firstName}</h2>
                <p className="text-sm">{selectedUser.email}</p>
              </div>
            </div>

            {/* Chat Messages */}
            <div className="flex-1 p-4 overflow-y-auto  bg-gray-50 scrollbar-hidden" ref={chatEndRef}>
              {[...fetchedMessages]
                .slice()
                // .reverse() // Reverse message order
                .map((msg) => (
                <div
                  key={msg.id}
                  className={`mb-4 ${msg.sender === "You" ? "text-right" : "text-left"
                    }`}
                >
                  <div
                    className={`inline-block p-3 rounded-lg ${msg.sender === "You"
                      ? "bg-orange-300"
                      : "bg-gray-300 text-black"
                      }`}
                  > 

                    {msg.content}
                    <span className="block text-xs mt-1 text-gray-500">
                      {msg.timestamp != null
                        ? formatTimestamp(msg.timestamp)
                        : "Sending..."}
                    </span>
                  </div>
                </div>
                
              ))}
            </div>
            

            {/* Message Input */}
            <div className="p-4 bg-gray-400 flex items-center">
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type a message"
                className="w-full p-2 rounded-lg border border-gray-300"
              />
              <button
                onClick={handleSendMessage}
                className="ml-2 bg-black text-white p-3 rounded-lg"
              >
                <AiOutlineSend />
              </button>
            </div>
          </>
        ) : (
          <div className="flex-1 flex justify-center items-center">
            <p className="text-xl text-gray-600">Select a subcontractor to chat</p>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default Chat;
